
import Approval from "locales/dental/en/approval/approval.json"
import ApprovelList from "locales/dental/en/approval/approvelList.json"

export const ApprovalEN ={
    ...Approval,
    ...ApprovelList
    
}